export enum RouteAction {
  Padrao = 'padrao',
  Editar = 'editar',
  Visualizar = 'visualizar',
  Inserir = 'inserir',
  Filtrar = 'fitrar',
  Bloquear = 'bloquear',
  Desligar = 'desligar',
  Afastar = 'afastar',
  Ativar = 'ativar',
  Readmitir = 'readmitir',
  Inativar = 'inativar',
  Cadastrar = 'cadastrar',
  Desativar = 'desativar',
  Excluir = 'excluir',
  Voltar = 'voltar',
  Cancelar = 'cancelar',
  Reaproveitar = 'reaproveitar',
  ResultadoPesquisa = 'resultadoPesquisa',
  AdicionarRoupa = 'adicionarRoupa',
  EditarRoupa = 'editarRoupa',
  Limpar = 'limpar',
  HabilitarEdicao = 'habilitarEdicao'
}

export enum LoginAction {
  TrocarSenha = 'trocarSenha',
  EsqueciMinhaSenha = "esqueciMinhaSenha"
}

export enum StatusEnum {
  Aprovado = 'Aprovado',
  Pendente = 'Pendente',
  Cancelado = 'Cancelado',
}
